export const FETCH_REQUESTS = 'FETCH_REQUESTS';
export const FETCH_REQUEST_COUNT = 'FETCH_REQUEST_COUNT';
export const ADD_REQUEST_SUCCESS = 'ADD_REQUEST_SUCCESS';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const CLEAN_REDUCER = 'CLEAN_REDUCER';
export const SET_SEARCH_REQUESTS = 'SET_SEARCH_REQUESTS';
